import Image from "next/image";
import arrowDown from "@/assets/icons/arrow-down.svg";
import Link from "next/link";

interface InfoCardProps {
  icon: string;
  text: string;
  buttonText: string;
  iconAlt: string;
  link: string;
}

export function InfoCard({
  icon,
  text,
  buttonText,
  iconAlt,
  link,
}: InfoCardProps) {
  return (
    <Link
      href={link}
      className="flex flex-col lg:flex-row items-start gap-8 md:gap-6 p-5 w-full bg-neutral-dark-200 hover:bg-neutral-dark-100 rounded-xl shadow-lg"
    >
      <div className="flex-shrink-0">
        <Image className="w-12 h-12" src={icon} alt={iconAlt} />
      </div>
      <div className="flex-grow flex flex-col gap-y-8">
        <p className="text-neutral-light-800 text-sm md:text-lg font-medium">
          {text}
        </p>
        <section className="flex gap-2 text-secondary-100 items-center">
          {buttonText}
          <div className="relative w-[18px] h-[18px]">
            <Image
              src={arrowDown}
              fill
              className="object-contain -rotate-90"
              alt="arrow"
            />
          </div>
        </section>
      </div>
    </Link>
  );
}
